import { __decorate, __metadata } from 'tslib';
import { Inject } from '@tencent/ioc';
import { SurfaceService } from '../../services/surface/surface-service.js';
import { StateManager } from '../../services/store/state-manager.js';
import { BuiltinUiState } from '../../services/store/builtin-state.js';

class AdapterCallback {
    constructor(id) {
        this.id = id;
        this.onBlur = () => { this.surfaceService.onBlur(this.id); };
        this.onFocus = () => { this.surfaceService.onFocus(this.id); };
        this.onDataChange = () => {
            if (this.shouldTrigger()) {
                this.store.update(BuiltinUiState.ModelTempState, { editor: this.id });
            }
        };
        this.onSelectionChange = (offset) => {
            if (this.shouldTrigger()) {
                this.store.update(BuiltinUiState.SelectionTempState, {
                    editor: this.id,
                    offset,
                });
            }
        };
        this.isReady = false;
    }
    shouldTrigger() {
        var _a;
        const focus = this.store.getValue(BuiltinUiState.FocusState);
        if (((_a = focus === null || focus === void 0 ? void 0 : focus.current) === null || _a === void 0 ? void 0 : _a.id) === this.id && this.isReady) {
            return true;
        }
        return false;
    }
    ready() {
        this.isReady = true;
    }
}
__decorate([
    Inject(),
    __metadata("design:type", SurfaceService)
], AdapterCallback.prototype, "surfaceService", void 0);
__decorate([
    Inject(),
    __metadata("design:type", StateManager)
], AdapterCallback.prototype, "store", void 0);

export { AdapterCallback };
//# sourceMappingURL=adapter-callback.js.map
